import { Settings } from "~/features/settings/index.tsx";

export const SettingsPage = () => {
	return <Settings />;
};
